import React from "react";
import { ReactNode } from "react";

export interface Heading2Props {
  heading?: ReactNode;
  subHeading?: ReactNode;
  className?: string;
  listingsCount: number;
}

const Heading2: React.FC<Heading2Props> = ({
  className = "",
  heading = "",
  subHeading,
  listingsCount,
}) => {
  return (
    <div className={`mb-12 lg:mb-16 ${className}`}>
      <h2 className="text-4xl font-semibold">{heading}</h2>
      {subHeading ? (
        subHeading
      ) : (
        <span className="block text-[#1f4c6f] font-bold text-lg dark:text-neutral-400 mt-3">
          {listingsCount} {listingsCount > 1 || listingsCount === 0 ? "listings" : "listing"}
        </span>
      )}
    </div>
  );
};

export default Heading2;
